<section id="patreon" class="patreon-section">
    <div class="flex__container flex__container--100 flex--center">
        <app-logo [item]="item"></app-logo>
    </div>
</section>